import React from "react";

export const ROOM_TYPES = ["Single", "Double", "Twin", "Suite", "Family"];

// Single-select room type. An empty value means "Any".
export default function RoomTypePills({ value, onChange, wrap = false }) {
  return (
    <div
      role="group"
      aria-label="Room type"
      className={`flex gap-2 ${wrap ? "flex-wrap" : "-mx-1 overflow-x-auto px-1 py-0.5 scrollbar-hide"}`}
    >
      {["", ...ROOM_TYPES].map(type => {
        const active = (value || "") === type;
        return (
          <button
            key={type || "any"}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(type)}
            className={`pill shrink-0 ${active ? "pill-active" : ""}`}
          >
            {type || "Any"}
          </button>
        );
      })}
    </div>
  );
}
